import { NgModule } from "@angular/core";
import { IngressHandlerDirective } from "./ingress-handler.directive";
import { CommonModule } from "@angular/common";

@NgModule({
  imports: [CommonModule],
  declarations: [IngressHandlerDirective],
  exports: [IngressHandlerDirective]
})

export class HandlerModule {}